export const styles = {
  color: {
    color: "#414141",
    fontSize: "1.17142857em",
  },
  feed_item: {
    marginBottom: 0,
  },
  date: {
    color: "rgba(0,0,0,.4)",
  },
};
// export const styles ={
// 	color:"#414141",
// 	fontSize: "1.07142857em"
// };
